import '../../styles/web-components/cart-progress.scss';
import { cartState$ } from '../services/cart.service';
class CartProgress extends HTMLElement {
    cartStateSub;
    constructor() {
        super();
    }
    connectedCallback() {
        this.cartStateSub = cartState$.subscribe((cart) => {
            this.onCartUpdate(cart);
        });
    }
    disconnectedCallback() {
        if (this.cartStateSub && !this.cartStateSub.closed) {
            this.cartStateSub.unsubscribe();
        }
    }
    render(config) {
        this.innerHTML = `
      <div class="cart-progress__threshold-message">${config.message}</div>
      <div class="cart-progress__threshold-container"><div class="cart-progress__threshold-bar" style="width:${config.percentDiff > 100 ? 100 : config.percentDiff}%"></div></div>
    `;
    }
    onCartUpdate(cart) {
        const thresholdData = buildThresholdData(cart.total_price, cart.original_total_price, { ...{ currentCurrency: window.UNTUCKitConfig.cartCurrencySymbol }, ...window.UNTUCKitConfig.thresholds });
        this.render(thresholdData);
    }
}
function buildThresholdData(totalPrice, originalTotalPrice, config) {
    let message = '';
    let percentDiff = null;
    const currency = config.currentCurrency;
    const totalPriceInMoney = totalPrice / 100;
    const originalTotalPriceInMoney = originalTotalPrice / 100;
    const punct = config.cartMessagingEndPunctuation;
    if (config.hasFreeShippingThreshold) {
        if (totalPriceInMoney < config.freeShippingThresholdAmount) {
            const diff = config.freeShippingThresholdAmount - totalPriceInMoney;
            percentDiff = totalPrice / config.freeShippingThresholdAmount;
            message = updateCopy(config.freeShippingPromoLabel, currency, diff);
        }
        else if (config.hasDiscountThreshold && originalTotalPriceInMoney < config.discountThresholdOriginalAmount) {
            const diff = config.discountThresholdAmount - totalPriceInMoney;
            percentDiff = totalPrice / config.discountThresholdAmount;
            message = `${config.freeShippingPromoQualifiedLabel}${punct} ${updateCopy(config.discountThresholdPromoLabel, currency, diff)}`;
        }
        else if (config.hasDiscountThreshold2 && originalTotalPriceInMoney < config.discountThresholdOriginalAmount2) {
            const diff = config.discountThresholdAmount2 - totalPriceInMoney;
            percentDiff = totalPrice / config.discountThresholdAmount2;
            message = updateCopy(`${config.discountThresholdQualifiedPromoLabel}${punct} ${config.discountThresholdPromoLabel2}`, currency, diff);
        }
        else if (config.hasDiscountThreshold2 && originalTotalPriceInMoney >= config.discountThresholdOriginalAmount2) {
            message = `${config.discountThresholdQualifiedPromoLabel2}`;
            percentDiff = 100;
        }
        else if (config.hasDiscountThreshold && originalTotalPriceInMoney >= config.discountThresholdOriginalAmount) {
            message = `${config.discountThresholdQualifiedPromoLabel}`;
            percentDiff = 100;
        }
        else {
            message = `${config.freeShippingPromoQualifiedLabel}`;
            percentDiff = 100;
        }
        message += punct;
        if (config.shipAfterLabel) {
            message += `<span>(${config.shipAfterLabel})</span>`;
        }
    }
    return { message, percentDiff };
}
function updateCopy(copy, currency, money) {
    return copy.replace("{money}", `${currency + money.toFixed(2)}`);
}
if (!window.customElements.get("cart-progress")) {
    customElements.define("cart-progress", CartProgress);
}
export const _forTesting = {
    buildThresholdData
};
